import { TranslateService } from '@ngx-translate/core';
import { NbMenuItem } from '@nebular/theme';
import { ChildrenOutletContexts } from '@angular/router';
import { GlobalConf } from '../shared/constant/GlobalConf';


console.log(GlobalConf.salleID);
export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'MENU_FARM_WEATHER',
    icon: 'nb-home',
    link: '/pages/dashboard',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuOperateur',
    },
  },
  {
    title: 'MENU_FARM_WEATHER',
    icon: 'nb-home',
    link: '/pages/dashboard',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuChefOperateur',
    },
  },
  {
    title: 'MENU_TASKS',
    icon: 'nb-locked',
    link: '/pages/taches',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuOperateur',
    },
  },
  {
    title: 'MENU_TRAINING',
    icon: 'nb-locked',
    link: '/pages/recette',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuOperateur',
    },
  },
  {
    title: 'MENU_PRODUCTION',
    icon: 'nb-locked',
    link: '/pages/recette',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuChefOperateur',
    },
  },
  {
    title: 'MENU_OPERATOR',
    icon: 'nb-locked',
    link: '/pages/recette',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuChefOperateur',
    },
  },
  {
    title: 'MENU_SALLE',
    icon: 'nb-gear',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuOperateur',
    },
    children: [
      {
        title: 'SUB_MENU_CULTURE',
        icon: 'nb-person', // goes into angular `routerLink`
        link: '/pages/salle/culture',
        queryParams: {id:GlobalConf.salleID[0]}

      },
      {
        title: 'SUB_MENU_GERMINATION',
        icon: 'nb-person', // goes into angular `routerLink`
        link: '/pages/salle/germination',
        queryParams: {id:GlobalConf.salleID[1]}

      },
      {
        title: 'SUB_MENU_HARVEST',
        icon: 'nb-person', // goes into angular `routerLink`
        link: '/pages/salle/recolte',
        queryParams: {id:GlobalConf.salleID[2]}
      },
      {
        title: 'Lavage',
        icon: 'nb-person', // goes into angular `routerLink`
        link: '/pages/salle/lavage',
        queryParams: {id:GlobalConf.salleID[3]}
      },
    ]
    ,
  },
  {
    title: 'MENU_SETTINGS',
    icon: 'nb-gear',
    home: true,
    data: {
      permission: 'view',
      resource: 'menuChefOperateur',
    },
    children: [
      {
        title: 'SUB_MENU_USER',
        icon: 'nb-person', // goes into angular `routerLink`
        link: '/pages/parametre/utilisateurs',

      },
      {
        title: 'SUB_MENU_TASKS',
        icon: 'nb-person', // goes into angular `routerLink`
        link: '/pages/parametre/tache',
      },
    ]
    ,
  },
];